import {
  ApiChartCrawler,
  ApiChartTemplate,
  ApiChartType,
  ApiDimension,
  ApiMetric,
  ApiOperator,
} from "@incendium/api";
import { Grid, Stack } from "@mui/material";
import { AnalyticsSpacing } from "consts";
import StandardAnalyticsCard from "features/analytics/components/StandardAnalyticsCard";
import { AnalyticsChartStatCard, table10Rows } from "features/analytics";
import {
  CHART_KEY_ORGANIC_CRAWLER_CRAWLED_PAGES_TABLE,
  CHART_KEY_ORGANIC_CRAWLER_NOT_CRAWLED_PAGES_TABLE,
  CHART_KEY_ORGANIC_CRAWLER_TOP_CRAWLERS_PIE,
  CHART_KEY_ORGANIC_CRAWLER_TOP_VISITS_TREND,
} from "features/analytics/constants/chartKeys";

function CrawlerAnalysis() {
  return (
    <Grid container spacing={AnalyticsSpacing} mb={4}>
      <Grid item xs={3}>
        <Stack spacing={AnalyticsSpacing}>
          <AnalyticsChartStatCard
            hideTrendedSpark
            noToolbar
            forceComparison
            chart={{
              name: "",
              dimension: [],
              template: ApiChartTemplate.SNAPSHOT,
              type: ApiChartType.GRAPH,
              attributes: [],
              crawler: ApiChartCrawler.ONLY_CRAWLERS,
              yAxisKeys: [
                {
                  key: "l",
                  fields: [ApiMetric.METRIC_SESSIONS_COUNT],
                },
              ],
              displayOptions: {
                statTitle: "No. Bot Visits",
              },
            }}
          />
          <AnalyticsChartStatCard
            hideTrendedSpark
            noToolbar
            forceComparison
            chart={{
              name: "",
              dimension: [],
              template: ApiChartTemplate.SNAPSHOT,
              type: ApiChartType.GRAPH,
              attributes: [],
              crawler: ApiChartCrawler.ONLY_CRAWLERS,
              yAxisKeys: [
                {
                  key: "l",
                  fields: [ApiMetric.METRIC_PAGEVIEWS_COUNT],
                },
              ],
              displayOptions: {
                statTitle: "Which Crawled",
              },
            }}
          />
          <AnalyticsChartStatCard
            hideTrendedSpark
            noToolbar
            topDimension={ApiDimension.DIMENSION_CRAWLER}
            forceComparison
            chart={{
              name: "",
              dimension: [ApiDimension.DIMENSION_CRAWLER],
              template: ApiChartTemplate.SNAPSHOT,
              type: ApiChartType.GRAPH,
              attributes: [],
              crawler: ApiChartCrawler.ONLY_CRAWLERS,
              yAxisKeys: [
                {
                  key: "l",
                  fields: [ApiMetric.METRIC_PAGEVIEWS_COUNT],
                },
              ],
              displayOptions: {
                statTitle: "Most Visited Bot",
              },
            }}
          />
        </Stack>
      </Grid>
      <Grid item xs={9} sx={{ minHeight: 401 }}>
        <StandardAnalyticsCard
          chartKey={CHART_KEY_ORGANIC_CRAWLER_TOP_VISITS_TREND}
          chart={{
            name: `Top 5 Crawler Visits`,
            dimension: [
              ApiDimension.DIMENSION_SESSION_START_BY_DAY,
              ApiDimension.DIMENSION_CRAWLER,
            ],
            template: ApiChartTemplate.TREND,
            type: ApiChartType.GRAPH,
            crawler: ApiChartCrawler.ONLY_CRAWLERS,
            limit: 5,
            attributes: [],
            yAxisKeys: [
              {
                key: "l",
                fields: [ApiMetric.METRIC_SESSIONS_COUNT],
              },
            ],
            displayOptions: {
              noFilters: true,
            },
          }}
        />
      </Grid>

      <Grid item xs={6} sx={{ minHeight: 480 }}>
        <StandardAnalyticsCard
          chartKey={CHART_KEY_ORGANIC_CRAWLER_CRAWLED_PAGES_TABLE}
          chart={{
            name: `Crawled Pages by`,
            dimension: [ApiDimension.DIMENSION_LOCATION],
            template: ApiChartTemplate.TABLE,
            type: ApiChartType.TABLE,
            limit: 5,
            crawler: ApiChartCrawler.ONLY_CRAWLERS,
            attributes: [],
            yAxisKeys: [
              {
                key: "l",
                fields: [
                  ApiMetric.METRIC_SESSIONS_COUNT,
                  ApiMetric.METRIC_PAGEVIEWS_COUNT,
                ],
              },
            ],
            displayOptions: {
              noFilters: true,
              availableDimensions: [
                ApiDimension.DIMENSION_LOCATION,
                ApiDimension.DIMENSION_PATH,
                ApiDimension.DIMENSION_PRODUCT_NAME,
                ApiDimension.DIMENSION_PRODUCT_CATEGORY,
                ApiDimension.DIMENSION_PRODUCT_BRAND,
              ],
            },
          }}
        />
      </Grid>

      <Grid item xs={6}>
        <StandardAnalyticsCard
          chartKey={CHART_KEY_ORGANIC_CRAWLER_TOP_CRAWLERS_PIE}
          chart={{
            name: "Top 20 Crawlers",
            dimension: [ApiDimension.DIMENSION_CRAWLER],
            template: ApiChartTemplate.SNAPSHOT,
            type: ApiChartType.PIE,
            limit: 20,
            crawler: ApiChartCrawler.ONLY_CRAWLERS,
            attributes: [],
            yAxisKeys: [
              {
                key: "l",
                fields: [ApiMetric.METRIC_SESSIONS_COUNT],
              },
            ],
            displayOptions: {
              noFilters: true,
              showTotals: true,
            },
          }}
        />
      </Grid>

      <Grid item xs={12} sx={{ minHeight: table10Rows }}>
        <StandardAnalyticsCard
          chartKey={CHART_KEY_ORGANIC_CRAWLER_NOT_CRAWLED_PAGES_TABLE}
          chart={{
            name: "Pages Visited But Not Crawled in This Time Period",
            dimension: [
              ApiDimension.DIMENSION_PATH,
              ApiDimension.DIMENSION_LOCATION,
            ],
            template: ApiChartTemplate.TABLE,
            type: ApiChartType.TABLE,
            crawler: ApiChartCrawler.WITH_CRAWLERS,
            attributes: [],
            orderBy: `${ApiMetric.METRIC_SESSIONS_COUNT} desc`,
            having: [
              {
                metric: ApiMetric.METRIC_CRAWLER_VISITS_COUNT,
                operator: ApiOperator.EQUAL,
                value: 0,
              },
            ],
            yAxisKeys: [
              {
                key: "l",
                fields: [
                  ApiMetric.METRIC_SESSIONS_COUNT,
                  ApiMetric.METRIC_PAGEVIEWS_COUNT,
                  ApiMetric.METRIC_MACRO_CONVERSION_RATE,
                  ApiMetric.METRIC_PAGE_MICRO_CONVERSION_RATE,
                  ApiMetric.METRIC_REVENUE,
                ],
              },
            ],
            displayOptions: {
              noFilters: true,
            },
          }}
        />
      </Grid>
    </Grid>
  );
}

export default CrawlerAnalysis;
